var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.166748 0.833333C0.166748 0.373096 0.539844 0 1.00008 0H16.0001C16.4603 0 16.8334 0.373096 16.8334 0.833333V5.83333C16.8334 6.03519 16.7601 6.23018 16.6272 6.38209L11.0001 12.8131V17.5C11.0001 17.8156 10.8217 18.1042 10.5394 18.2454L7.20609 19.912C6.94777 20.0412 6.64099 20.0274 6.39531 19.8755C6.14962 19.7237 6.00008 19.4555 6.00008 19.1667V12.8131L0.372934 6.38209C0.240013 6.23018 0.166748 6.03519 0.166748 5.83333V0.833333ZM1.83341 1.66667V5.52022L7.46056 11.9512C7.59348 12.1032 7.66675 12.2981 7.66675 12.5V17.8183L9.33341 16.985V12.5C9.33341 12.2981 9.40668 12.1032 9.5396 11.9512L15.1667 5.52022V1.66667H1.83341Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.57f4e67c763ee48cef3a3b1553f61ea2.svg";
export { ForwardRef as ReactComponent };